import React, { useRef, useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { UPDATE_HOUSE_ENTRANCE_API_URL } from '../Optics/OpticApiConfig';
import CustomSnackbar from '../Optics/Components/CustomSnackbar';
import { Snackbar } from '@mui/material';

const ModalvVewingHouse = ({ open, onClose, street, houseNumber, entrances, hid, coordinates, searchAddress }) => {
  
  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  
  const mapRef = useRef();
  const [editMode, setEditMode] = useState(false);
  const [markers, setMarkers] = useState(coordinates);
  const [movedMarkers, setMovedMarkers] = useState([]);


  // useEffect(() => {
  //   if (mapRef.current && coordinates.length > 0) {
  //     const map = mapRef.current;
  //     map.setView([coordinates[0].latitude, coordinates[0].longitude], 18);
  //   }
  // }, [coordinates]);

  // const close = () => {
  //   onClose();
  // };
   useEffect(() => {
    if (mapRef.current && coordinates.length > 0) {
      const map = mapRef.current;
      map.setView([coordinates[0].latitude, coordinates[0].longitude], 18);
    }
    setMarkers(coordinates); // обновляем состояние при смене данных
  }, [coordinates]);

  const close = () => {
    onClose();
    setEditMode(false);
    setMovedMarkers([]);
    searchAddress();
  };

   const toggleEditMode = () => {
    setEditMode(!editMode);
    setMovedMarkers([]);
  };

const handleSave = async () => {
  const formatted = movedMarkers.map((m) => ({
    hid: hid, 
    entrance: m.entrance,
    latitude: m.position.lat,
    longitude: m.position.lng,
  }));

  //console.log("Изменённые маркеры:", formatted);

  try {
     const token = localStorage.getItem("token"); 
    const response = await fetch(`${UPDATE_HOUSE_ENTRANCE_API_URL}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify(formatted),
    });

    if (!response.ok) {
      //throw new Error("Ошибка при обновлении");
      showSnackbar(`Ошибка при обновлении`, 'snackbarWarning');
    }

    const result = await response.json();
    //console.log("Успешно обновлено:", result);
    showSnackbar(`Обновлено: ${result.updated} подъездов!`, 'snackbarWarning');
  } catch (error) {
    // console.error("Ошибка:", error);
     showSnackbar(`Подъезды без изменений`, 'snackbarWarning');
  }

  // сброс
  setEditMode(false);
  setMovedMarkers([]);
};

  return (
    <Dialog open={open} className="modalStyleUpTer">
      <DialogContent>
        <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset' }}>Просмотр дома</label>
         {!editMode ? (
            <button className="buttonIsHideModalUpTer" onClick={toggleEditMode} style={{marginLeft: '10px'}}>
              Редактировать подъезды
            </button>
          ) : (
            <button className="buttonIsHideModalUpTer" onClick={handleSave} style={{marginLeft: '10px'}}>
              Сохранить
            </button>
          )}
        <hr className='horizontalLineModalUpTer' />
        <div>
          <label style={{color: "orange"}}>Адрес: <span style={{color: "#c5c5c5"}}> ул. {street}, дом: {houseNumber}</span></label>
          <br/>
          <label style={{color: "orange"}}>Подъездов: <span style={{color: "#c5c5c5"}}>{entrances}</span></label>
           {/* Кнопки управления */}
         
          <div style={{ height: '400px', width: '100%', borderRadius: '10px', marginTop: '10px' }}>
            <MapContainer
              center={coordinates.length > 0 ? [coordinates[0].latitude, coordinates[0].longitude] : [50.38098, 30.45241]}
              zoom={18}
              minZoom={12}
              style={{ height: '100%', width: '100%', borderRadius: "10px"}}
              ref={mapRef}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
              {markers.map((marker, index) => (
                <Marker
    key={index}
    position={[marker.latitude, marker.longitude]} // <-- берём из state markers
    draggable={editMode}
    eventHandlers={{
      dragend: (e) => {
        const newPos = e.target.getLatLng();

        // обновляем markers
        const updatedMarkers = markers.map((m, i) =>
          i === index ? { ...m, latitude: newPos.lat, longitude: newPos.lng } : m
        );
        setMarkers(updatedMarkers);

        // добавляем в movedMarkers
        setMovedMarkers((prev) => {
          const exists = prev.find((m) => m.entrance === marker.entrance);
          if (exists) {
            return prev.map((m) =>
              m.entrance === marker.entrance
                ? { ...m, position: newPos }
                : m
            );
          } else {
            return [...prev, { entrance: marker.entrance, position: newPos }];
          }
        });
      },
    }}
    icon={L.icon({
      iconUrl: "./entrance.png",
      iconSize: [30, 30],
      iconAnchor: [15, 15],
    })}
  >
    <Popup className="custom-popupUpTer">Подъезд: {marker.entrance}</Popup>
  </Marker>
                // <Marker 
                //   key={index}
                //   position={[coord.latitude, coord.longitude]}
                //   icon={L.icon({ iconUrl: './entrance.png', iconSize: [30, 30], iconAnchor: [15, 15] })}
                // >
                //   <Popup className="custom-popupUpTer">
                //       Подъезд: {coord.entrance}
                //   </Popup>
                // </Marker>
              ))}
            </MapContainer>
          </div>
          <hr className='horizontalLineModalUpTer' />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} class='buttonIsHideModalUpTer'>
          Закрыть
        </Button>
      </DialogActions>

       {/* Snackbar */}
              <Snackbar
                anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
                }}
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                message={snackbarMessage}
                ContentProps={{
                  style: {
                    color: snackbarClass === 'snackbarOk' ? 'orange' : 'orange'
                  }
                }}
              />
    </Dialog>
  );
};

export default ModalvVewingHouse;
